import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_contact_hdr_RowClass} from '../../../dbschema/bl_crm_contact_hdr.model';

export class ContactHeaderContainerModel extends BaseContainerModel {
  bl_crm_contact_hdr: bl_crm_contact_hdr_RowClass = new bl_crm_contact_hdr_RowClass();
}
